import React from "react"
import { useState } from "react"


export default function Card(props: {
    detailCard: React.JSX.Element
    customTitleJSX?: React.JSX.Element
    detailColor: string
    detailTitle: string
    backgroundImage?: any
    backgroundColor?: string
    borderColor?: string
    stateShow?: boolean
}) {
    const { detailCard, customTitleJSX, detailColor, detailTitle, backgroundImage, stateShow, backgroundColor, borderColor } = props
    const [showDetails, setShowDetails] = useState<boolean>(stateShow ?? false)

    return (
        <div style={{
            background: backgroundImage != null ? `url(${backgroundImage})` : '',
            backgroundColor: backgroundColor != null ? `${backgroundColor}` : '',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'bottom',
            padding: "1vh", borderRadius: "12px", margin: "1vh 0vw", border: borderColor != null ? `2px solid ${borderColor}` : '2px solid var(--secondary-color)'
        }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'end', fontWeight: "600", cursor: "pointer" }} onClick={() => setShowDetails(!showDetails)} >
                {customTitleJSX ? '' : <div></div>}
                {customTitleJSX ?? <div style={{ color: detailColor ?? 'black', fontSize: '2.5vh' }}>{detailTitle ?? 'DETAILS'}</div>}
                <div style={{ color: detailColor ?? 'black', fontSize: '2.5vh', float: 'right', transition: "transform 0.3s", transform: showDetails ? 'rotate(+90deg)' : 'rotate(0deg)' }}>{">"}</div>
            </div>
            {showDetails === true ? <hr style={{ color: detailColor ?? 'black', border: '1px solid', margin: "1vh 0vw", }}></hr> : ''}
            <div>
                {showDetails === true ? detailCard : ''}
            </div>
        </div>
    )
}

